import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import { AuthProvider } from './context/AuthContext';

// Pages
import Home from './pages/Home';
import Contact from './pages/Contact';
import Capabilities from './pages/Capabilities';
import Architecture from './pages/Architecture';
import IdentityCoE from './pages/IdentityCoE';
import WhyIdentityMatters from './pages/WhyIdentityMatters';
import Offerings from './pages/Offerings';
import ROI from './pages/ROI';
import Insights from './pages/Insights';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';

// Industry pages
import Government from './pages/industries/Government';
import BFSI from './pages/industries/BFSI';
import Infrastructure from './pages/industries/Infrastructure';
import DigitalNatives from './pages/industries/DigitalNatives';

export default function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

function AppContent() {
  return (
    <div className="min-h-dvh bg-[var(--bg-primary)] text-[var(--text-primary)]">
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/capabilities" element={<Capabilities />} />
          <Route path="/architecture" element={<Architecture />} />
          <Route path="/identity-coe" element={<IdentityCoE />} />
          <Route path="/why-identity-matters" element={<WhyIdentityMatters />} />
          <Route path="/offerings" element={<Offerings />} />
          <Route path="/roi" element={<ROI />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/login" element={<Login />} />
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Industry routes */}
          <Route path="/industries/government" element={<Government />} />
          <Route path="/industries/bfsi" element={<BFSI />} />
          <Route path="/industries/infrastructure" element={<Infrastructure />} />
          <Route path="/industries/digital-natives" element={<DigitalNatives />} />
          
          {/* Legacy redirects */}
          <Route path="/industries/digital-native" element={<DigitalNatives />} />
          <Route path="/industries/defence" element={<Infrastructure />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
